// Case-insensitive substring match of a trimmed query against a label; empty/whitespace queries never match.
export const queryMatchesLabel = (query: string, label: string): boolean => {
	const q = query.trim().toLowerCase();
	return q.length > 0 && label.toLowerCase().includes(q);
};
